import React from 'react';
import { useSetRecoilState } from 'recoil';
import { Label } from '@nooz-optics/nooz-components-lib';
import '../../../../../../styles/global.css';
import { variantState } from 'utils/recoil/product';
import clsx from 'clsx';
import { Button } from '../../../../../UI/Elements';

export const ProductMainSizePicker: React.FC<ProductMainSizePickerProps> = ({
  label,
  variant,
  sizes,
  category,
  hasBorder,
}) => {
  const setVariant = useSetRecoilState(variantState);

  const returnSizeSublabel = () => {
    let sizeSubLabel = '';
    sizes?.forEach((size) => {
      if (variant.size?.value === size.value) {
        sizeSubLabel = size.body?.richBody?.references[1]?.text;
      }
    });
    return sizeSubLabel;
  };

  const returnSizeButtons = () =>
    sizes?.map((size, index) => {
      const isSizeSelected = variant.size?.value === size.value;
      const isLastSize = index === sizes.length - 1;
      return (
        <div className={clsx(`${!isLastSize && 'mr-2'}`, 'mb-4')}>
          <Button
            size='base'
            type='contained'
            color={isSizeSelected ? category?.color : { classname: 'white' }}
            label={{ text: size.body?.richBody?.references[0]?.text }}
            onClick={() => setVariant({ ...variant, size })}
          />
        </div>
      );
    });

  return (
    <div className={`w-full ${hasBorder ? 'border-b' : ''}`}>
      <div className='flex my-3 items-center'>
        <Label
          weight='bold'
          text={label?.text}
        />
        &nbsp;&#45;&nbsp;
        <Label text={returnSizeSublabel()} />
      </div>
      <div className='flex flex-wrap'>{returnSizeButtons()}</div>
    </div>
  );
};
